import React from "react";
import { Redirect, Route } from "react-router-dom";
import auth from "./Authenticate";
import NotFoundPage from "../Pages/NotFoundPage/NotFoundPage";
import { useUserMode } from "@UserModeContext";
import checkPermissions from '../Helpers/PagesPermissions/RolesPermissionsParser';
import setupProperitiesHandler from "../Security/SetupProperitiesHandler";

const ProtectedRoute = ({ component: Component, permissions, ...rest }) => {
	const userModeState = useUserMode();
	if(auth.loggedIn() && auth.getUserRole("ADMIN") !== "ADMIN" && auth.getUserRole("EDITOR") !== "EDITOR" && !userModeState.userMode){
		userModeState.toggle()
	}
	return (
		<Route
			{...rest}
			render={(props) => {

				if (rest.path === "/") {
					let redirect = null;
					if (auth.getUserRole("G_ADMIN") === "G_ADMIN")
						redirect = "/zarzadzanie-firmami";
					else if (userModeState.userMode)
						redirect = "/dokumenty";
					else
						redirect = "/edycja-dokumentow";
					return (
						<Redirect
							to={{
								pathname: redirect,
								state: { from: props.location },
							}}
						/>
					);
				}

				const permitted = checkPermissions(permissions, userModeState.userMode);

				if (permitted === true) 
					return <Component {...props} />;
				else {
					let redirect = null;
					if (auth.loggedIn() === false) {
						if (setupProperitiesHandler.get('first_setup') === true)
							redirect = "/pierwsza-konfiguracja";
						else
							redirect = "/login";

					} else 
						redirect = "/";

					return (
						<Redirect
							to={{
								pathname: redirect,
								state: { from: props.location },
							}}
						/>
					);
				}
			}}
		></Route>
	);
};

export default ProtectedRoute;
